module.exports = __webpack_public_path__ + "img/restaurant.63782c3d.jpg";